import React, { useContext } from "react";

import { FeatureGatingContext } from "../../contexts";
import { Select } from "../../components/ui";

const CHRONO24 = "chrono24";
const WATCH_COLLECTING = "watch_collecting";
const WATCH_FINDER = "watch_finder";
const WATCH_ANALYTICS = "watch_analytics";
const WATCH_CHARTS = "watch_charts";
const EBAY = "ebay";

const marketplaces = [
  { id: CHRONO24, name: "Chrono24" },
  { id: WATCH_COLLECTING, name: "WatchCollecting" },
  { id: WATCH_FINDER, name: "WatchFinder" },
  { id: WATCH_ANALYTICS, name: "WatchAnalytics" },
  { id: WATCH_CHARTS, name: "WatchCharts" },
  { id: EBAY, name: "Ebay" },
];
const OPTIONS = marketplaces.map(({ id, name }) => ({ value: id, label: name }));

const getLink = (marketplace, item) => {
  const ref = item.reference_number;
  switch (marketplace) {
    case CHRONO24:
      return `https://www.chrono24.com/search/index.htm?dosearch=true&query=${ref}`;
    case WATCH_COLLECTING:
      return `https://watchcollecting.com/?production_watches%5Bquery%5D=${ref}`;
    case WATCH_FINDER:
      return `https://www.watchfinder.com/search?q=${ref}`;
    case WATCH_ANALYTICS:
      return `https://watchanalytics.io/en/search/${ref}`;
    case WATCH_CHARTS:
      return `https://marketplace.watchcharts.com/listings?page=1&q=${ref}`;
    case EBAY:
      return `https://www.ebay.com/sch/i.html?_from=R40&_trksid=p4432023.m570.l1313&_nkw=${ref}&_sacat=0`;
    default:
      return null;
  }
};

export function MarketplaceActions({ item, fieldClassName }) {
  const { checkFeatureQuota } = useContext(FeatureGatingContext);

  const goToMarketplace = async (marketplace) => {
    const allowed = await checkFeatureQuota(
      FeatureGatingContext.features.MARKETPLACE_ACCESS
    );
    if (!allowed) {
      return;
    }

    const link = getLink(marketplace, item);
    if (link) {
      window.open(link, "_blank");
    }
  };

  // An action picker, not a value: it always reads "Marketplace" and each pick opens that site.
  return (
    <Select
      className={fieldClassName || undefined}
      label="Marketplace"
      placeholder="Marketplace"
      data-btn="marketplace-open"
      fullWidth
      options={OPTIONS}
      value={null}
      onChange={goToMarketplace}
    />
  );
}
